/*
 * Layout view for the snippet page, which is a simplified version of the topic page
 */

define([
  "marionette",
  "i18n/i18n",
  "modules/topicsSplit/snippet/template/snippetTemplate.html",
], function (Marionette, i18next, SnippetTemplate) {
  "use strict";

  const SnippetView = {};

  // noinspection JSUnusedGlobalSymbols
  SnippetView.snippetLayout = Marionette.Layout.extend({
    className: "snippet-view",
    template: SnippetTemplate,
    regions: {
      snippet: "#snippetArea",
      response: "#snippetResponse",
    },
    triggers: {
      "click #editSnippetResponse": "edit:snippet:response",
      "click #deleteSnippet": "delete:snippet",
    },
    textboxes: function () {
      if (!this.model.isReadOnly) {
        return {
          "#snippetNameText": {
            enableSelector: "#snippetNameText",
            modelAttribute: "name",
            placeholder: "snippet.name",
            textArea: false,
          },
          "#snippetDescription": {
            enableSelector: "#snippetDescription",
            modelAttribute: "description",
            placeholder: "snippet.description",
            textArea: true,
          },
        };
      }
    },
    templateHelpers: {
      getLanguageName: function (languageId) {
        if (!languageId) {
          return i18next.t("snippet.anyLanguage");
        }
        const thisModel = this.model || this._thisObject;
        const language = thisModel.languages.get(languageId);
        return language ? language.get("name") : languageId;
      },
      getTouchpointName: function (touchpointId) {
        if (!touchpointId) {
          return i18next.t("snippet.anyTouchpoint");
        }
        const thisModel = this.model || this._thisObject;
        const touchpoint = thisModel.touchpoints.get(touchpointId);
        return touchpoint ? touchpoint.get("touchPoint") : touchpointId;
      },
    },
    getLanguageId: function () {
      const languageId = this.$el.find("#snippetLanguage").val();
      return languageId ? +languageId : null;
    },
    getTouchpointId: function () {
      const touchpointId = this.$el.find("#snippetTouchpoint").val();
      return touchpointId ? +touchpointId : null;
    },
  });

  return SnippetView;
});
